<template>
	<div>
		<div class="card">
			<div class="card-header py-3 bold text-uppercase text-dark">
				<fa-icon
					icon="info"
					class="mr-2"
				/> General
			</div>

			<div class="card-body">
				<div class="row">
					<div class="col-12 col-sm-4">
						<label class="d-block text-gray-6">Nombre:</label>
						{{ value.EmpresaNombreComercial }}
					</div>

					<div class="col-12 col-sm-4 ">
						<label class="d-block text-gray-6">Razón Social:</label>
						{{ value.EmpresaNombre }}
					</div>

					<div class="col-12 col-sm-4">
						<label class="d-block text-gray-6">CIF / NIF / NIE:</label>
						{{ value.EmpresaCIF }}
					</div>
				</div>
			</div>
		</div>

		<div class="card">
			<div class="card-header py-3 bold text-uppercase text-dark">
				<fa-icon
					icon="map-marker"
					class="mr-2"
				/> Datos Geográficos
			</div>

			<div class="card-body">
				<div class="row mb-4">
					<div class="col-12">
						<label class="d-block text-gray-6">Domicilio Social:</label>
						<text-value :value="value.EmpresaDomicilioSocial" />
					</div>
				</div>

				<div class="row">
					<div class="col-12 col-sm-3">
						<label class="d-block text-gray-6">CP:</label>
						<text-value :value="value.EmpresaCP" />
					</div>

					<div class="col-12 col-sm-3">
						<label class="d-block text-gray-6">Localidad:</label>
						<text-value :value="value.EmpresaLocalidad" />
					</div>

					<div class="col-12 col-sm-3">
						<label class="d-block text-gray-6">Provincia:</label>
						<text-value :value="value.EmpresaProvincia" />
					</div>

					<div class="col-12 col-sm-3">
						<label class="d-block text-gray-6">Pais:</label>
						<text-value :value="value.EmpresaPais" />
					</div>
				</div>
			</div>
		</div>

		<div class="card">
			<div class="card-header py-3 bold text-uppercase text-dark">
				<fa-icon
					icon="map-marker"
					class="mr-2"
				/> Datos de facturación
			</div>

			<div class="card-body">
				<div class="row mb-4">
					<div class="col-12">
						<label class="d-block text-gray-6">Forma de pago:</label>
						{{ $gestios.$utils.getValue(
							'empresas',
							'EmpresaFormaPago',
							value.EmpresaFormaPago
						) }}
					</div>
				</div>

				<div class="row">
					<div class="col-12 col-sm-6">
						<label class="d-block text-gray-6">IBAN:</label>
						<text-value :value="value.EmpresaCuentaBancaria" />
					</div>

					<div class="col-12 col-sm-6">
						<label class="d-block text-gray-6">BIC/SWIFT:</label>
						<text-value :value="value.EmpresaBIC" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: Object,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
